import { useMutation, useQuery, useQueryClient } from 'react-query'
import { updateCollegeUser, useAppDispatch } from 'state'

import { API_ENDPOINTS } from 'config/api'
import axios from 'config/axios'

import {
  CollegeRefferals,
  CollegeRefferalsApiResponse,
  CollegeUser,
  CollegeUserApiResponse,
  PaymentResponse,
  SendOtpAndVerifyOtpResponseType,
  VerifyPaymentResponse
} from '../types/college.types'

/**
 * for fetching College student by userId
 */
export const fetchCollegeStudnet = async (userId?: string) => {
  const response = await axios.get(
    `${API_ENDPOINTS.COLLEGE_STUDENTS}/${userId}`
  )
  const data = response.data as CollegeUserApiResponse

  return { collegeStudentId: data.data.id, ...data.data.attributes }
}

export const useCollegeStudent = (userId: string) => {
  const dispatch = useAppDispatch()
  return useQuery<CollegeUser, null>(
    ['College-student', { userId }],
    () => fetchCollegeStudnet(userId),
    {
      enabled: !!userId,
      onSuccess: (data) => {
        dispatch(updateCollegeUser(data))
      }
    }
  )
}

/**
 * for Sending Otp
 */
export const fetchSendOtp = async (phoneNumber: string) => {
  const response = await axios.post(
    `${API_ENDPOINTS.USER}/send_otp?phone_number=${phoneNumber}&verification_type=college_registration`
  )

  const data = response.data as SendOtpAndVerifyOtpResponseType
  return data
}

export const useSendOtpMutation = () => {
  return useMutation(fetchSendOtp)
}

/**
 * for Verifying Otp
 */
export const fetchVerifyOtp = async ({
  phoneNumber,
  otp,
  collegeStudentId
}: {
  phoneNumber: string
  otp: string
  collegeStudentId: string
}) => {
  const response = await axios.post(
    `${API_ENDPOINTS.USER}/verify_phone_number?otp=${otp}&phone_number=${phoneNumber}&student_id=${collegeStudentId}&verification_type=college_registration`
  )

  const data = response.data as SendOtpAndVerifyOtpResponseType
  return data
}

export const useVerifyOtpMutation = (userId: string) => {
  const queryClient = useQueryClient()
  return useMutation(fetchVerifyOtp, {
    onSuccess: () => {
      queryClient.invalidateQueries(['College-student', { userId }])
    }
  })
}

/**
 * For Payment
 */
type PaymentOptions = {
  amount: number
  currency: string
  description: string
}

const fetchPatymentLink = async (paymentOptions: PaymentOptions) => {
  const response = await axios.post(API_ENDPOINTS.PAYMENT_ORDER, {
    ...paymentOptions
  })

  const { data } = response.data as PaymentResponse

  return data.attributes.payment_link
}

export const useGetPaymentLink = () => {
  return useMutation(fetchPatymentLink)
}

/**
 * For Verifying Payment
 */

export type VerifyPaymentBody = {
  razorpay_payment_id: string
  razorpay_payment_link_id: string
  razorpay_payment_link_reference_id: string
  razorpay_payment_link_status: string
  razorpay_signature: string
}

const fetchPaymentStatus = async (verifyPaymentBody: VerifyPaymentBody) => {
  const response = await axios.post(
    API_ENDPOINTS.PAYMENTS_VERIFY,
    verifyPaymentBody
  )

  const { data } = (await response.data) as VerifyPaymentResponse

  return data.attributes.status
}

export const useVerifyPayment = () => {
  return useMutation(fetchPaymentStatus)
}

/*
 * to get college referral data
 * */

export const fetchCollegeReferralData = async () => {
  const response = await axios.get(
    `${API_ENDPOINTS.USER_REFERRAL}?referral_type=devsnest_college`
  )
  const data = response.data as CollegeRefferalsApiResponse

  return data.data.attributes.referrals
}

export const useFetchCollegeReferralData = () => {
  return useQuery<CollegeRefferals, null>(
    ['user_college_referral'],
    fetchCollegeReferralData
  )
}
